import { useState, useEffect } from "react";
import styles from "../css/toggleTabs.module.css"
import { LuCar } from "react-icons/lu";
import { PiPersonSimpleHike } from "react-icons/pi";

function ToggleTabs({ active, onChange, setQuery, disabled}) {

  const [selected, setSelected] = useState(active || "trips");

  useEffect(() => {
    const saved = localStorage.getItem("activeTab");
    if (saved) {
      setSelected(saved);
      onChange(saved);
    }
  }, []);

  const handleSelect = (type) => {
    setSelected(type);
    localStorage.setItem("activeTab", type);
    onChange(type);
    setQuery('')
  };

  return (
    <div className={`${styles.tabsWrapper} userSelectNone`}>
      <button
        className={`${styles.tab} ${selected === "trips" ? styles.active : ""}`}
        disabled={disabled}
        onClick={() => handleSelect("trips")}
      >
        <LuCar size={18} />
        <span>Przejazdy</span>
      </button>

      <button
        className={`${styles.tab} ${selected === "hikes" ? styles.active : ""}`}
        disabled={disabled}
        onClick={() => handleSelect("hikes")}
      >
        <PiPersonSimpleHike size={18} />
        <span>Wyprawy</span>
      </button>
    </div>
  );
}

export default ToggleTabs;
